import { useCallback } from 'react';
import { Box, Collapse, Grid } from '@mui/material';

import { Typography, Switches, CardHeader } from '@occc-app/design-system';
import { EarningMechanismAwardSelector } from '@occc-app/offerHelpers/components/earning-mechanism-award-selector';
import { AwardType } from '@occc-app/offerHelpers/types';
import { OfferFilter, Offer_Engagement_Type, Publication_Status_Type } from '@occc/graphql';
import { useChainId } from '@occc-app/Chain/hooks';

import { WalletFormValues } from '../types';

type IncentivizeResponsesProps = {
  values: Partial<WalletFormValues>;
};

export const IncentivizeResponses: React.FC<IncentivizeResponsesProps> = ({ values }) => {
  const chainId = useChainId();

  const makeOffersFilter = useCallback(
    (_search: string): OfferFilter => ({
      chainIdEquals: chainId,
      engagementTypeIncludes: [
        Offer_Engagement_Type.Vouchered,
        Offer_Engagement_Type.SweepstakesEntry,
      ],
      publicationStatusEquals: Publication_Status_Type.Published,
      deleted: false,
    }),
    [chainId],
  );

  return (
    <>
      <Grid item xs={12}>
        <CardHeader
          title={
            <Typography variant='h6' component='p' gutterBottom>
              Incentivize Responses
            </Typography>
          }
          subheader={
            <Typography color='textSecondary'>
              Incentivize responses by giving members points or awards for responding to your Wallet
              Survey
            </Typography>
          }
          action={<Switches name='incentivizeResponses.isEnabled' data={{}} />}
          sx={{ p: 0 }}
        />
        <Collapse in={values?.incentivizeResponses?.isEnabled} timeout='auto' unmountOnExit>
          <Box pt={3}>
            <EarningMechanismAwardSelector
              buttonTypes={[AwardType.AwardPoints, AwardType.AwardVouchers]}
              makeOffersFilter={makeOffersFilter}
              values={{
                awardType: values.incentivizeResponses?.awardType as AwardType,
              }}
              fieldNamePrefix='incentivizeResponses.'
              isTitleVisible={false}
            />
          </Box>
        </Collapse>
      </Grid>
    </>
  );
};
